import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import appUtil from '@/vue-dlb/utils/app-util'
import {UploadFile} from '@/vue-dlb/models'
import config from '@/vue-caas/config/config.js';

import {
  commitRetDataSets,
  showProgress
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  execSPByDataSet,
  callByDataSet,
  selectUserDataSet,
} from "@/vue-dlb/utils/backend-util.js";

import { get } from "lodash";

const isDlbMybatis = config.isDlbMybatis;

const state = {
  mainGrid: [],
  historyList: [],
  dataSet01Source: [],
  mapNameList: [],
};

const getters = {
};

const actions = {
  queryList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("mainGrid");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    // 203737 SPKA-49 issue 5 apply date conndition
    trSet.tranID = "EDP_MPD_LIST_MAN_MPD_MST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  updateLock: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("updateLock");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "MapDefinitionManager";
      trSet.tranMethod = "updateLock";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_MPD_UPD_MAN_MPD_LOCK_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  queryHistoryList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("historyList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryHistoryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_MPD_LIST_MAN_MPD_HST_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  saveCurrentVer: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("saveCurrentVer");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "MapDefinitionManager";
      trSet.tranMethod = "saveCurrentVer";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_MPD_UPD_MAN_MPD_CURVER_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deleteMapDefinition: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deleteMapDefinition");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "MapDefinitionManager";
    trSet.tranMethod = "deleteMapDefinition";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deleteSelectedHistory: async ({ commit }, paramItems) => {
    /// Insert Data
    let condSet3 = new ObjDataSet("condSet");
    const trSet3 = new ObjTrSet("deleteSelectedHistory");
    condSet3 = appUtil.addDataHeader(paramItems, condSet3);
    trSet3.AddDataSet("I", "DS01", condSet3);
    trSet3.tranID = "MapDefinitionManager";
    trSet3.tranMethod = "deleteMapDefinitionHistory";
    const reqdata = callByDataSet(trSet3);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  queryMapNameList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("mapNameList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryMapNameList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_MPD_LIST_MAN_GET_MAP_NAME_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  saveAddMapDefinition: async ({ commit }, paramItems) => {
    let uploadfile = new UploadFile();
    uploadfile.data[0].DIV_KUBUN = 'ASSET';
    uploadfile.data[0].BIZ_KUBUN = 'FILE_MPD';
    uploadfile.data[0].SITE_CODE = paramItems.data[0].CUST_ID;
    uploadfile.data[0].USER_KUBUN = $cookies.get('user-id');
    uploadfile.data[0].SUB_DIR = '';
    uploadfile.data[0].RENAME_YN = 'Y';
    uploadfile.data[0].FILE_NAME = paramItems.data[0].mpdfile.name;
    uploadfile.data[0].file = paramItems.data[0].mpdfile;
    const retSet = new ObjDataSet("UploadedFile");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("saveAddMapDefinitionLocal");
    condSet = appUtil.addDataHeader(uploadfile, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
    const formData = new FormData();
    formData.append('file', uploadfile.data[0].file, uploadfile.data[0].FILE_NAME);
    formData.append('trSet', JSON.stringify(trSet));
    await api.trFileSend("Fileupload", formData).then(res => {
      let resdata = res.data;
      var trset = JSON.parse(JSON.stringify(resdata));
      var datasets = trset.DataSets;
      var datarows = datasets[0].DataRows;
      paramItems.data[0].FILE_ID = datarows[0].FILE_NAME;
      paramItems.data[0].FILE_SIZE = datarows[0].FILE_BYTE;
      paramItems.data[0].MPD_FILE_NAME = paramItems.data[0].mpdfile.name;
    });
    /// Insert Data
    let condSet3 = new ObjDataSet("condSet");
    const trSet3 = new ObjTrSet("savdAddMapDefinitionInsertData");
    condSet3 = appUtil.addDataHeader(paramItems, condSet3);
    trSet3.AddDataSet("I", "DS01", condSet3);
    trSet3.tranID = "MapDefinitionManager";
    trSet3.tranMethod = "saveAddMapDefinition";
    const reqdata = callByDataSet(trSet3);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  checkInMapDefinition: async ({ commit }, paramItems) => {
    let uploadfile = new UploadFile();
    uploadfile.data[0].DIV_KUBUN = 'ASSET';
    uploadfile.data[0].BIZ_KUBUN = 'FILE_MPD';
    uploadfile.data[0].SITE_CODE = paramItems.data[0].CUST_ID;
    uploadfile.data[0].USER_KUBUN = $cookies.get('user-id');
    uploadfile.data[0].SUB_DIR = '';
    uploadfile.data[0].RENAME_YN = 'Y';
    uploadfile.data[0].FILE_NAME = paramItems.data[0].mpdfile.name;
    uploadfile.data[0].file = paramItems.data[0].mpdfile;
    const retSet = new ObjDataSet("UploadedFile");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("checkInMapDefinition");
    condSet = appUtil.addDataHeader(uploadfile, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
    const formData = new FormData();
    formData.append('file', uploadfile.data[0].file, uploadfile.data[0].FILE_NAME);
    formData.append('trSet', JSON.stringify(trSet));
    await api.trFileSend("Fileupload", formData).then(res => {
      let resdata = res.data;
      var trset = JSON.parse(JSON.stringify(resdata));
      var datasets = trset.DataSets;
      var datarows = datasets[0].DataRows;
      paramItems.data[0].FILE_ID = datarows[0].FILE_NAME;
      paramItems.data[0].FILE_SIZE = datarows[0].FILE_BYTE;
      paramItems.data[0].MPD_FILE_NAME = paramItems.data[0].mpdfile.name;
    });

    /// Insert Data
    let condSet3 = new ObjDataSet("condSet");
    const trSet3 = new ObjTrSet("checkInMapDefinition");
    condSet3 = appUtil.addDataHeader(paramItems, condSet3);
    trSet3.AddDataSet("I", "DS01", condSet3);
    trSet3.tranID = "MapDefinitionManager";
    trSet3.tranMethod = "checkInMapDefinition";
    const reqdata = callByDataSet(trSet3);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
}

const mutations = {
  mainGrid (state, datarows) {
    state.mainGrid = datarows;
    state.dataSet01Source = datarows;
  },
  historyList (state, datarows) {
    state.historyList = datarows;
  },
  mapNameList(state, datarows) {
    state.mapNameList = datarows;
  },
  'SET_STORE_MAP_DEFINITION_FILTER' (state, filter) {
    let datarows = state.dataSet01Source;
    state.filter = filter;
    let filterBy = state.filter;
    let listResult = [];
    if (filterBy != null) {
      let filter = filterBy.filter;
      let str = filterBy.str;
      if (str.trim() == '') {
        listResult = datarows;
      }
      listResult = datarows.filter(item =>  {
        if(filter == 'all') {
          for (const prop in item) {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        } else {
          if (typeof item[filter] == 'string') {
            let propValue = item[filter].toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          } else if (typeof item[filter] == 'number') {
            let propValue = item[filter].toString().toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          }
        }

        return false;
      });
    }
    state.mainGrid = listResult;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
